import { createAction } from 'redux-actions'
import {
  integrationsCatalogTileClick,
  integrationsCatalogButtonClick,
  integrationsCatalogAddSourceClick,
  integrationsCatalogSourceClick
} from 'analytics'
import {
  getActiveWorkspace,
  getSourceSettingBySlug
} from 'selectors'

export const SET_CATALOG_OVERVIEW_SETTINGS = 'SET_CATALOG_OVERVIEW_SETTINGS'
export const setCatalogOverviewSettings = createAction(SET_CATALOG_OVERVIEW_SETTINGS)

export const SET_CATALOG_DETAIL_SETTINGS = 'SET_CATALOG_DETAIL_SETTINGS'
export const setCatalogDetailSettings = createAction(SET_CATALOG_DETAIL_SETTINGS)

export function trackIntegrationsCatalogTileClick (integrationSlug) {
  return function (dispatch, getState) {
    const state = getState()
    const workspace = getActiveWorkspace(state)

    integrationsCatalogTileClick(workspace, integrationSlug)
  }
}

export function trackIntegrationsCatalogButtonClick (integrationSlug, button) {
  return function (dispatch, getState) {
    const state = getState()
    const workspace = getActiveWorkspace(state)

    integrationsCatalogButtonClick(workspace, integrationSlug, button)
  }
}

export function trackIntegrationsCatalogAddSourceClick (integrationSlug, popover) {
  return function (dispatch, getState) {
    const state = getState()
    const workspace = getActiveWorkspace(state)

    integrationsCatalogAddSourceClick(workspace, integrationSlug, popover)
  }
}

export function trackIntegrationsCatalogSourceClick (integrationSlug, sourceSlug, popover) {
  return function (dispatch, getState) {
    const state = getState()
    const workspace = getActiveWorkspace(state)
    const source = getSourceSettingBySlug(state, workspace.slug, sourceSlug)

    integrationsCatalogSourceClick(workspace, integrationSlug, source, popover)
  }
}



// WEBPACK FOOTER //
// ./actions/catalog.js